import { defineVideoTemplate } from "@assets/templates/builders";
import { BASE_ASSETS } from "@assets/templates/constants";

export const ambulanceSirenExample = defineVideoTemplate({
  slug: "ambulance-siren-example",
  title: "Firetruck siren",
  description: "Firetruck siren timing",
  subdescription: "Use audio clues to find when the siren starts",
  poster: BASE_ASSETS.firetruckSirenPoster,
  video: BASE_ASSETS.firetruckSirenVideo,
  prompt: "Clip the moment the siren starts.",
  featured: true,
  temperature: 0,
  annotationFormat: "clip",
  enableThinking: false,
  enableAudioInVideo: true,
});
